import { doc, updateDoc } from 'firebase/firestore'
import { db } from '@/config/firebase'
import type { CheckpointStatus, Waypoint } from '@/types/project'

/**
 * Replace a project's route checkpoints (admin only, per firestore.rules).
 * `waypoints` is a plain, server-storable array (no server-owned fields), so the
 * project update rule permits it.
 */
export async function setProjectWaypoints(projectId: string, waypoints: Waypoint[]): Promise<void> {
  await updateDoc(doc(db, 'projects', projectId), { waypoints })
}

/** Set one checkpoint's status by rewriting the (small) waypoints array. */
export async function setWaypointStatus(
  projectId: string,
  waypoints: Waypoint[],
  waypointId: string,
  status: CheckpointStatus,
): Promise<void> {
  const next = waypoints.map((wp) => (wp.id === waypointId ? { ...wp, status } : wp))
  await setProjectWaypoints(projectId, next)
}

/** Set the final-leg / destination arrival status (admin only). */
export async function setDeliveryStatus(
  projectId: string,
  status: CheckpointStatus,
): Promise<void> {
  await updateDoc(doc(db, 'projects', projectId), { deliveryStatus: status })
}
